
/* X feed 5番目以降削除
------------------------------*/
let list_element = document.querySelectorAll("#twitter_feed li");

for (let i = 4; i < list_element.length; i++) {
    list_element[i].remove();
}